import React from 'react';
import Hero from '../Hero';
import AboutSection from '../Section/AboutSection';
import ImageDescriptionSection from '../Section/ImageDescriptionSection';
import DescriptionSection from '../Section/DescriptionSection';
import BrandsSection from '../Section/BrandsSection';
import Banner from '../Section/BannerSection';
import Section from '../Section';
import FeaturesSection from '../Section/FeaturesSection';
import TestimonialSection from '../Section/TestimonialSection';
import BlogSection from '../Section/BlogSection';
import AppointmentSection from '../Section/AppointmentSection';
import FaqSection from '../Section/FaqSection';
// import AwardSection from '../Section/AwardSection';
import WhySection from '../Section/WhySection';
import DepartmentSection from '../Section/DepartmentSection';
import Lister from '../Section/Lister';
import { pageTitle } from '../../helpers/PageTitle';
import { COMPANY_NAME, COMPANY_EMAIL, COMPANY_LOCATION, COMPANY_PHONE_DISPLAY, COMPANY_PHONE_TEL, COMPANY_WHATSAPP } from '../../constants/brand';
const featureListData = [
  {
    iconSrc: '/images/home_1/eye.svg',
    title: 'Vision',
    subTitle:
      'Position Kerala as a global leader in holistic healing, leveraging its unparalleled healthcare and tourism resources.',
  },
  {
    iconSrc: '/images/home_1/target.svg',
    title: 'Mission',
    subTitle:
      'To establish a transparent and efficient platform integrating Kerala’s healthcare and tourism sectors, enabling seamless access to world-class services for patients and tourists.',
  },
  // {
  //   iconSrc: '/images/home_1/integrity.svg',
  //   title: 'Integrity',
  //   subTitle: `We believe in practicing medicine with integrity and honesty. We are transparent in our communication and decision-making processes, and we always put our patient's interests first & provide best solution.`,
  // },
  // {
  //   iconSrc: '/images/home_1/respect.svg',
  //   title: 'Respect',
  //   subTitle:
  //     'We treat all individuals with respect and dignity, regardless of their background, beliefs, or circumstances. We believe that every person deserves to be treated with compassion and kindness.',
  // },
  // {
  //   iconSrc: '/images/home_1/teamwork.svg',
  //   title: 'Teamwork',
  //   subTitle:
  //     'We believe in working collaboratively with our team membersvand other healthcare professionals to provide comprehensive and effective care to our patients.',
  // },
];
const nriData = [
  {title: 'Medical & Tourist Visa Assistance', description: 'End-to-end support for visa processing.'},
  {title: 'Accommodation Arrangements', description: 'Stay options from budget hotels to luxury resorts.'},
  {title: 'Airport Pickup & Local Transport', description: 'Seamless travel solutions for patients and families.'},
  {title: 'Second Opinion & Pre-Travel Consultation', description: 'Online consultations with expert doctors.'},
  {title: 'Dedicated NRI Support', description: '24/7 assistance for medical and travel queries.'},
  {title: 'Wellness Retreats', description: 'Personalized Ayurveda, yoga, and meditation programs.'},
  {title: 'Flexible Treatment Scheduling', description: 'Tailored plans based on availability and travel preferences.'},
  {title: 'Accommodation Options - 3 Star, 4 Star Or 5 Star'},
  {title: 'Daily Cab Services - Premium Cab Or Sedan Cab'}
];
const nriDescp = `${COMPANY_NAME} offers specialized International & NRI Services, ensuring a seamless and stress-free medical journey. From visa assistance and travel logistics to personalized healthcare solutions, we provide comprehensive support to international patients and NRIs seeking quality treatment in Kerala. With expert guidance and dedicated assistance, we make medical travel simple, efficient, and affordable.`
const brandData = [
  { imgUrl: 'images/home_1/partners/aster.png', imgAlt: 'Aster Medicity - Cochin' },
  { imgUrl: 'images/home_1/partners/kims.png', imgAlt: 'KIMS Al Shifa Hospital - Perinthalmanna' },
  { imgUrl: 'images/home_1/partners/lakeshore.png', imgAlt: 'Lakeshore Hospital - Cochin' },
  { imgUrl: 'images/home_1/partners/rajagiri.png', imgAlt: 'Rajagiri Hospital - Cochin' }
];
const faqData = [
  {
    title: `What is ${COMPANY_NAME}?`,
    content:
      `${COMPANY_NAME} is a medical tourism facilitator that connects international and NRI patients with top hospitals and wellness centers in Kerala.`,
  },
  {
    title: 'What medical treatments are available?',
    content:
      'We offer treatments including orthopedic surgeries, oncology care, fertility services, Ayurveda, dental care, neurology, and physiotherapy.',
  },
  {
    title: 'Do you assist with medical visas?',
    content:
      'Yes, we provide medical visa assistance, including document guidance and invitation letters from hospitals.',
  },
  {
    title: 'Can I get a second opinion before traveling?',
    content:
      'Yes, we offer online consultations with top specialists to help you make an informed decision before traveling.',
  },
  {
    title: 'What accommodation options are available?',
    content:
      'We arrange stays in three-star, four-star, and five-star hotels, as well as serviced apartments and wellness retreats.',
  },
  {
    title: 'Do you provide airport pickup and local transport?',
    content:
      'Yes, we offer airport transfers and daily cab services for a smooth travel experience.',
  },
  {
    title: 'Are Ayurveda, yoga, and meditation services available?',
    content:
      'Yes, we offer personalized wellness retreats featuring Ayurveda treatments, yoga, and meditation.',
  },
  {
    title: 'How do I book a consultation?',
    content:
      'You can book a free online consultation through our website or contact us via WhatsApp, email, or phone.',
  },
  {
    title: 'Is post-treatment care available?',
    content:
      'Yes, we provide post-treatment follow-ups and online consultations for continued recovery support.',
  },
  {
    title: `How can I contact ${COMPANY_NAME}?`,
    content:
      `You can reach us via email at ${COMPANY_EMAIL} or call us at ${COMPANY_PHONE_DISPLAY}.`,
  },
];
const blogData = [
  {
    title: 'Kerala: The Ultimate Destination for World-Class Medical Tourism',
    thumbUrl: 'images/home_1/blogs/1.jpg',
    date: 'Feb 19, 2025',
    btnText: 'Learn More',
    href: '/blog/kerala-the-ultimate-destination-for-world-class-medical-tourism',
    socialShare: false,
  },
  {
    title: 'Ayurveda & Holistic Healing: Why Tourists Choose Kerala for Wellness',
    thumbUrl: 'images/home_1/blogs/2.jpg',
    date: 'Feb 19, 2025',
    btnText: 'Learn More',
    href: '/blog/ayurveda-holistic-healing-why-tourists-choose-kerala-for-wellness',
    socialShare: false,
  },
  {
    title: 'A Complete Guide to Medical Travel in Kerala: What to Expect',
    thumbUrl: 'images/home_1/blogs/3.jpg',
    date: 'Feb 19, 2025',
    btnText: 'Learn More',
    href: '/blog/a-complete-guide-to-medical-travel-in-kerala-what-to-expect',
    socialShare: false,
  },
];
const whyData = [
  {
    title: 'Free Consultations & Second Opinions',
    subTitle:
      'Online medical and travel consultations, including expert second opinions, to help you choose the best treatment plan at a cost-effective price.',
    iconUrl: 'images/icons/tick_white.svg',
  },
  {
    title: 'Comprehensive Healthcare',
    subTitle:
      'From specialized care to holistic wellness programs.',
    iconUrl: 'images/icons/tick_white.svg',
  },
  {
    title: 'End-to-End Travel Assistance',
    subTitle:
      'Seamless travel, accommodation, and local logistics.',
    iconUrl: 'images/icons/tick_white.svg',
  },
  {
    title: 'Global Network',
    subTitle:
      'Worldwide partners providing visa and ticketing support.',
    iconUrl: 'images/icons/tick_white.svg',
  },
  {
    title: 'Prevention-Focused Care',
    subTitle:
      'Encouraging preventive healthcare for long-term well-being.',
    iconUrl: 'images/icons/tick_white.svg',
  },
  {
    title: 'Yoga, Meditation, and Ayurveda',
    subTitle:
      'Holistic programs tailored for peace, happiness, and wellness.',
    iconUrl: 'images/icons/tick_white.svg',
  },
  {
    title: 'Multilingual Team',
    subTitle:
      'Personalized services catering to diverse nationalities.',
    iconUrl: 'images/icons/tick_white.svg',
  },
  {
    title: 'Expert Boards',
    subTitle:
      'Managed by top doctors, tour operators, and hospitality specialists.',
    iconUrl: 'images/icons/tick_white.svg',
  },
  {
    title: 'Kerala: A Global Hub',
    subTitle:
      "Access world-class healthcare and tourism in God's Own Country.",
    iconUrl: 'images/icons/tick_white.svg',
  },
  {
    title: 'Affordable Healthcare',
    subTitle: 'World-class treatments at competitive prices.',
    iconUrl: 'images/icons/tick_white.svg',
  },
  {
    title: 'Seamless Experience',
    subTitle: 'Integrated healthcare, travel, and accommodation support.',
    iconUrl: 'images/icons/tick_white.svg',
  },
  {
    title: 'Post-Treatment Care',
    subTitle: 'Ongoing support, including online consultations.',
    iconUrl: 'images/icons/tick_white.svg',
  },
];
const departmentData = [
  {
    title: 'Knee Replacement',
    iconUrl: 'images/home_1/medical_services/1.jpg',
    href: '/departments/department-details',
    description: "Advanced orthopedic solutions ensuring mobility and pain relief."
  },
  {
    title: 'Neurospinal Treatments',
    iconUrl: 'images/home_1/medical_services/2.jpg',
    href: '/departments/department-details',
    description: "Specialized treatments for neurological and spinal conditions."
  },
  {
    title: 'Prostate Surgery',
    iconUrl: 'images/home_1/medical_services/3.jpg',
    href: '/departments/department-details',
    description: "Expert urological care with minimally invasive techniques."
  },
  {
    title: 'Dental Wellness',
    iconUrl: 'images/home_1/medical_services/4.jpg',
    href: '/departments/department-details',
    description: "High-quality dental care from cosmetic to restorative treatments."
  },
  {
    title: 'Skin & Dermatology Care',
    iconUrl: 'images/home_1/medical_services/5.jpg',
    href: '/departments/department-details',
    description: 'Comprehensive skin treatments for a radiant, healthy look.'
  },
  {
    title: 'Diabetes & Thyroid Care',
    iconUrl: 'images/home_1/medical_services/6.jpg',
    href: '/departments/department-details',
    description: "Specialized programs to manage endocrine disorders."
  },
  {
    title: 'IVF Treatments & Gynaecology Services',
    iconUrl: 'images/home_1/medical_services/7.jpg',
    href: '/departments/department-details',
    description: "Expert reproductive healthcare solutions."
  },
  {
    title: 'Oncology Care',
    iconUrl: 'images/home_1/medical_services/8.jpg',
    href: '/departments/department-details',
    description: "Holistic cancer care with leading oncologists."
  },
  {
    title: 'Physiotherapy',
    iconUrl: 'images/home_1/medical_services/9.jpg',
    href: '/departments/department-details',
    description: "Customized rehabilitation programs for mobility restoration."
  },
  {
    title: 'Ayurveda Wellness Therapies',
    iconUrl: 'images/home_1/medical_services/10.jpg',
    href: '/departments/department-details',
    description: "Traditional healing treatments for complete well-being."
  },
  {
    title: 'Plastic Surgery',
    iconUrl: 'images/home_1/medical_services/11.jpg',
    href: '/departments/department-details',
    description: "Advanced cosmetic and reconstructive surgery."
  },
];

export default function Home() {
  pageTitle('Home');
  return (
    <>
      <Hero
        id="home"
        title="Your Gateway to World-Class Healthcare in Kerala"
        subTitle="Seamless medical travel solutions with expert care and holistic wellness experiences."
        bgUrl="/images/home_1/hero_bg.jpeg"
        imgUrl="/images/home_1/hero_img.png"
        videoBtnText="See how we work"
        videoUrl="https://www.youtube.com/embed/iW681vrqmw8"
        infoList={[
          {
            title: 'Connect With Us',
            subTitle: COMPANY_PHONE_DISPLAY,
            iconUrl: '/images/contact/icon_1.svg',
            url: COMPANY_PHONE_TEL
          },
          {
            title: 'Email Us',
            subTitle: COMPANY_EMAIL,
            iconUrl: '/images/contact/icon_2.svg',
            url: `mailto:${COMPANY_EMAIL}`
          },
          {
            title: 'Location',
            subTitle: COMPANY_LOCATION,
            iconUrl: '/images/icons/pin.svg',
            url: 'https://maps.com'
          },
        ]}
        // btnText="Book Now"
        // btnUrl="/appointments"
        btnText="Chat With Us"
        btnUrl={COMPANY_WHATSAPP}
      />
      {/* Start Feature Section */}
      <Section
        topSm={50}
        topMd={185}
        topLg={140}
        topXl={100}
        bottomSm={50}
        bottomMd={185}
        bottomLg={140}
        bottomXl={100}
      >
        <FeaturesSection sectionTitle="Our Values" data={featureListData} />
      </Section>
      {/* End Feature Section */}
      {/* Start About Section */}
      <Section id="about">
        <AboutSection
          imgUrl="/images/home_1/about.png"
          spiningImgUrl="/images/home_1/about_mini.svg"
          title="About Us"
          subTitle={COMPANY_NAME}
          featureList={[
            {
              featureListTitle:
                'Bridging Healthcare & Tourism Seamlessly',
              featureListSubTitle:
                `At ${COMPANY_NAME}, we bridge healthcare and tourism to provide seamless medical travel experiences. Our mission is to position Kerala as a global leader in medical tourism, offering advanced treatments, holistic wellness programs, and personalized care. With expert guidance, end-to-end travel support, and a commitment to excellence, we ensure a stress-free journey for patients seeking world-class healthcare in India.`,
            },
          ]}
        />
      </Section>
      {/* End About Section */}
      {/* Start NRI Section */}
      <Section
        topSm={50}
        topMd={185}
        topLg={140}
        topXl={100}
        bottomSm={50}
        bottomMd={30}
        bottomLg={40}
        bottomXl={80}
        id="services"
      >
        <Lister sectionTitle="International & NRI Services" data={nriData} description={nriDescp} />
      </Section>
      {/* End NRI Section */}
      {/* Start Tourism Section */}
      <Section>
        <ImageDescriptionSection
          imgUrl="/images/home_1/explore.png"
          spiningImgUrl="/images/home_1/about_mini.svg"
          title="Explore India"
          subTitle="Tailored Tours for Every Traveler"
          description={[
            `India is a land of diverse cultures, breathtaking landscapes, and rich heritage. At ${COMPANY_NAME}, we offer expertly curated tour packages for international tourists, NRIs, and domestic travelers, ensuring a seamless and unforgettable travel experience. Whether you dream of witnessing the majestic Taj Mahal, exploring the historic India Gate, cruising through Kerala’s serene backwaters, or discovering the royal palaces of Rajasthan, we handle all your travel arrangements with precision. From accommodation and transport to guided tours, we ensure a hassle-free journey so you can fully immerse yourself in India’s wonders.`,
            `Our customized tours cater to different travel preferences, whether it's cultural exploration, spiritual retreats, adventure trips, or luxury getaways. Enjoy personalized itineraries that suit your interests, allowing you to experience India’s most famous landmarks, hidden gems, and vibrant traditions. Whether you’re visiting for leisure, business, or post-medical treatment relaxation, ${COMPANY_NAME} guarantees a comfortable, enriching, and memorable journey across India’s most spectacular destinations.`
          ]}
        />
      </Section>
      {/* End Tourism Section */}
      {/* Start Departments Section */}
      <Section topMd={70} topLg={70} topXl={70} topSm={70}>
        <DepartmentSection
          sectionTitle="Medical Services"
          bgUrl="images/home_1/hero_bg.jpeg"
          data={departmentData}
        />
      </Section>

      {/* End Departments Section */}
      {/* Start Why Choose Section */}
      <Section topMd={185} topLg={140} topXl={100} topSm={70}>
        <WhySection sectionTitle={`Why Choose ${COMPANY_NAME}?`} data={whyData} />
      </Section>
      {/* End Why Choose Section */}
      {/* Start Channel Partner Section */}
      <Section
        topSm={50}
        topMd={55}
        topLg={50}
        topXl={50}
        bottomSm={0}
        bottomMd={0}
        bottomLg={0}
        bottomXl={0}
      >
        <DescriptionSection
        sectionTitle="Global Channel Partners"
        sectionDescription="Seamless Assistance Worldwide"
        description={[
          `${COMPANY_NAME} has a strong network of channel partners across the globe, ensuring smooth and hassle-free medical travel for international patients. Our partners assist travelers in visa processing, flight bookings, currency exchange, and essential travel arrangements before they even arrive in India.`,
          "From selecting the right hospital, booking accommodation, and arranging meals to securing local transportation and taxi services, our global partners provide end-to-end support. With their expertise, patients can focus on their treatment and recovery while we take care of the logistics, making the journey to India stress-free and comfortable."
        ]} />
      </Section>
      {/* End Channel Partner Section */}
      {/* Start Testimonial */}
      <Section
        topMd={185}
        topLg={140}
        topXl={100}
        topSm={70}
        bottomMd={0}
        bottomLg={0}
        bottomXl={0}
        bottomSm={70}
        id="reviews"
      >
        <TestimonialSection
          sectionTitle="Some Reviews"
          sectionTitleDown="Of our clients"
        />
      </Section>
      {/* End Testimonial */}
      {/* Start Banner Section */}
      <Section>
        <Banner
          bgUrl="images/home_1/hero_bg.jpeg"
          imgUrl="images/home_1/consult.png"
          title="Don’t Let Your Health Take a Backseat!"
          subTitle="Schedule an appointment with one of our experienced medical professionals today!"
          btnText="Chat With Us"
          btnUrl={COMPANY_WHATSAPP}
        />
      </Section>
      {/* End Banner Section */}
      {/* Start Blog Section */}
      <Section topMd={100} topLg={100} topXl={90} topSm={70} id="blogs">
        <BlogSection
          sectionTitle="Latest Update"
          sectionTitleUp="BLOG POSTS"
          data={blogData}
        />
      </Section>
      {/* End Blog Section */}
      {/* Start Appointment Section */}
      <Section topMd={190} topLg={145} topXl={105} topSm={70} id="appointment">
        <AppointmentSection
          sectionTitle="Appointment"
          sectionTitleUp="BOOK AN"
          imgUrl="/images/home_1/doctor.png"
          btnText="Chat With Us"
          btnUrl={COMPANY_WHATSAPP}
          description="Scheduling your medical consultation has never been simpler. Whether you're planning your treatment or need expert guidance, we offer multiple ways to connect with us. Book your appointment via phone, WhatsApp, email, or by visiting us directly—whichever suits you best. Our team is here to assist you every step of the way, ensuring a smooth and stress-free experience."
        />
      </Section>
      {/* End Appointment Section */}
      {/* Start FAQ Section */}
      <Section topMd={100} topLg={100} topXl={90} topSm={70} id="faq">
        <FaqSection
          data={faqData}
          sectionTitle="Usually Asked"
          sectionTitleUp="What People"
        />
      </Section>
      {/* End FAQ Section */}
      {/* Start Brand Section */}
      <Section
        topMd={70}
        topLg={70}
        topXl={60}
        topSm={40}
        bottomMd={70}
        bottomLg={70}
        bottomXl={60}
        bottomSm={40}
      >
        <BrandsSection data={brandData} />
      </Section>
      {/* End Brand Section */}
    </>
  );
}
